export default __webpack_public_path__ + "static/media/cancer.7aa31a59.png";